<script setup>
// import SpinnerHtml from "../components/SpinnerHtml.vue"
</script>
<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex align-items-center p-3 my-3 text-dark-50 bg-lightblue rounded shadow-sm">
          <div class="lh-100">
            <h6 class="border-bottom border-gray pb-2 mb-0 lh-100">Number Integration</h6>
          </div>
          <button type="submit" class="btn btn-success ml-auto" @click="openModelClickMethod" data-toggle="modal"
                  data-target="#exampleModal">
            <span> &#43; &nbsp;New</span>
          </button>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead class="text-bold">
            <tr>
              <th scope="col">NAME</th>
              <th scope="col">NUMBER</th>
              <th scope="col">PHONE NUMBER ID</th>
              <th scope="col">WhatsApp Business Account ID</th>
              <th scope="col">DATETIME</th>
              <th scope="col">ACTION</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in tables" :key="row.id">
              <td scope="row">{{ row.name }}</td>
              <td>{{ row.phonenumber }}</td>
              <td>{{ row.phonenumberId }}</td>
              <td>{{ row.whatsAppId }}</td>
              <td>{{ format_date(row.timestamp) }}</td>
              <td>
                <button type="button" @click="integrationAction(index, 'edit')" class="btn btn-success"
                        data-toggle="modal"
                        data-target="#exampleModal">Edit
                </button>
                <button type="button" @click="integrationAction(index, 'delete')" class="btn btn-danger">Delete</button>
                <button type="button" @click="integrationAction(index, 'disable')" class="btn btn-primary" v-show="row.enable">Active</button>
                <button type="button" @click="integrationAction(index, 'enable')" class="btn btn-warning" v-show="!row.enable">In-Active</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!--    model begin-->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
         aria-labelledby="exampleModalLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">New Integration</h5>
            <button type="button" ref="modalClose" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit="onSubmit">
            <div class="modal-body">
              <div class="form-group">
                <label for="integration-name" class="col-form-label">Name:<span
                    class="text-danger">*</span></label>
                <input type="text" class="form-control" maxlength="30" v-model="form.name" id="integration-name"
                       required>
              </div>
              <div class="form-group">
                <label for="integration-phonenumber" class="col-form-label">Phone Number:<span
                    class="text-danger">*</span></label>
                <input type="text" class="form-control" minlength="10" maxlength="10" v-model="form.phonenumber"
                       id="integration-phonenumber" required>
              </div>
              <div class="form-group">
                <label for="integration-phonenumber-id" class="col-form-label">Phone Number ID:<span
                    class="text-danger">*</span></label>
                <input type="text" class="form-control" minlength="15" maxlength="18" v-model="form.phonenumberId"
                       id="integration-phonenumber-id" required>
              </div>
              <div class="form-group">
                <label for="integration-whatsApp-id" class="col-form-label">WhatsApp Business Account ID:<span
                    class="text-danger">*</span></label>
                <input type="number" class="form-control" minlength="15" maxlength="18" v-model="form.whatsAppId"
                       id="integration-whatsApp-id" required>
              </div>
              <div class="form-group">
                <label for="integration-token-id" class="col-form-label">Permanent Access Token:<span
                    class="text-danger">*</span></label>
                <textarea class="form-control" id="integration-token-id" rows="3"
                          placeholder="Paste permanent token here..." minlength="30" maxlength="300"
                          v-model="form.token" required></textarea>
              </div>
              <div class="form-group">
                <label for="integration-upload-limit" class="col-form-label">Upload limit:<span
                    class="text-danger">*</span></label>
                <input type="number" class="form-control" min="1" max="250000" v-model="form.uploadLimit"
                       id="integration-upload-limit" required>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-primary">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--    model end-->
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment/moment";

export default {
  data() {
    return {
      form: {
        name: '',
        phonenumber: '',
        phonenumberId: '',
        token: '',
        whatsAppId: '',
        uploadLimit: ''
      },
      tables: [],
      show: true
    }
  },
  async created() {
    var getTemp = await this.getNumberIntegrationList();
    this.tables = getTemp.data.message;
  },
  methods: {
    async onSubmit(event) {
      event.preventDefault()
      if (confirm('Are you sure to save?')) {
        this.begin_loading()
        var form = new FormData();
        form.append('name', this.form.name);
        form.append('phonenumber', this.form.phonenumber);
        form.append('phonenumberId', this.form.phonenumberId);
        form.append('whatsAppId', this.form.whatsAppId);
        form.append('token', this.form.token);
        form.append('uploadLimit', this.form.uploadLimit);
        // const config = {
        //   // 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
        //   // headers: {
        //   //   'Content-Type': 'multipart/form-data'
        //   // }
        // }
        const NMPUSER = JSON.parse(localStorage.getItem('NMPUSER'))
        if (!(localStorage.getItem('NMPUSER') && NMPUSER && Object.prototype.hasOwnProperty.call(NMPUSER, "token") && NMPUSER.token && NMPUSER.token == this.waId  && NMPUSER.token != "")) {
          this.$router.push('/');
          return false;
        }
        const config = {
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': NMPUSER.token,
          }
        }
        await axios.post('/whatsApp/number_integration',
            {
              name: this.form.name,
              phonenumber: this.form.phonenumber,
              phonenumberId: this.form.phonenumberId,
              accessToken: this.form.token,
              whatsAppId: this.form.whatsAppId,
              uploadLimit: this.form.uploadLimit
            }, // the data to post
            config).then(response => {
          var responseTitle;
          if (response.data.status) {
            responseTitle = {title: "Success", icon: "success"};
          } else {
            responseTitle = {title: "Failed", icon: "error"};
          }
          this.$swal({
            title: responseTitle.title,
            html: response.data.message,
            icon: responseTitle.icon,
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        });
        this.end_loading()
        this.form = {
          name: '',
          phonenumber: '',
          phonenumberId: '',
          whatsAppId: '',
          token: '',
          uploadLimit: ''
        };
        this.$refs.modalClose.click();
        var getTemp = await this.getNumberIntegrationList();
        this.tables = getTemp.data.message;
      }
    }, onFileChange(event) {
      this.form.fileUpload = event.target.files[0]
    },
    onReset(event) {
      event.preventDefault()
      // Reset our form values
      this.form.template = ''
      this.form.name = ''
      this.form.food = null
      this.form.checked = []
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    async getNumberIntegrationList() {
      // // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/message_templates?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/whatsApp/number_integration_list';
      return await this.axiosRequest(templateURL, {
        waId: this.waId
      });
    },
    format_date(value) {
      if (value) {
        return moment(value).format('DD-MM-YYYY hh:mm:ss a');
      } else {
        return "";
      }
    },
    async integrationAction(index, mode) {
      this.form = {
        name: '',
        phonenumber: '',
        phonenumberId: '',
        whatsAppId: '',
        token: '',
        uploadLimit: ''
      };
      if (mode == 'edit') {
        const selectedRow = this.tables[index] || {};
        this.form = {
          ...selectedRow,
          uploadLimit: selectedRow.uploadLimit ?? selectedRow.upload_limit ?? ''
        }
      } else if (mode == 'delete') {
        let phonenumber = this.tables[index].phonenumber
        this.$swal({
          title: 'Are you sure?',
          text: 'you going to delete this integration',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, Delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(async result => {
          if (result.isConfirmed) {
            let getAxiosRequest = await this.axiosRequest('/whatsApp/number_integration_delete', {phonenumber: phonenumber});

            var responseTitle;
            if (getAxiosRequest.data.status) {
              responseTitle = {title: "Success", icon: "success"};
            } else {
              responseTitle = {title: "Failed", icon: "error"};
            }
            this.sweetAlert(responseTitle.icon, responseTitle.title, getAxiosRequest.data.message, 'btn-primary');
            var getTemp = await this.getNumberIntegrationList();
            this.tables = getTemp.data.message;
          }
        })
      } else {
        let phonenumber = this.tables[index].phonenumber
        this.$swal({
          title: 'Are you sure?',
          text: `you going to ${mode} this integration`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: `Yes, ${mode} it!`,
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(async result => {
          if (result.isConfirmed) {
            let getAxiosRequest = await this.axiosRequest('/whatsApp/number_integration_enable_disable', {phonenumber: phonenumber, mode: mode});

            var responseTitle;
            if (getAxiosRequest.data.status) {
              responseTitle = {title: "Success", icon: "success"};
            } else {
              responseTitle = {title: "Failed", icon: "error"};
            }
            this.sweetAlert(responseTitle.icon, responseTitle.title, getAxiosRequest.data.message, 'btn-primary');
            var getTemp = await this.getNumberIntegrationList();
            this.tables = getTemp.data.message;
          }
        })
      }
    },
    openModelClickMethod() {
      this.form = {
        name: '',
        phonenumber: '',
        phonenumberId: '',
        whatsAppId: '',
        token: '',
        uploadLimit: ''
      };
    }
  }
}
</script>
<style>
@media (min-width: 1024px) {
  .about {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}

.bg-lightblue {
  background-color: lightblue;
}

/*td {*/
/*  white-space: normal !important;*/
/*  word-wrap: break-word;*/
/*}*/
/*table {*/
/*  table-layout: fixed;*/
/*}*/
</style>
